import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createGtag, event, pageview} from "vue-gtag";
import axios from 'axios'
import VueAxios from 'vue-axios'
import { createHead } from '@vueuse/head'
import { global } from "./utils";

const app = createApp(App);

const gtag = createGtag({
  //tagId: "G-8NSXJK432E", //DEV
  tagId: "G-33EQD6TC67", // prod
  config: {
    send_page_view: false,
  },
})

function trackPage(to) {
  const utmData = extractUTMParams(to);

  pageview({
    page_path: to.fullPath,
    page_title: to.meta?.title || document.title,
    ...utmData
  });

  if (Object.keys(utmData).length > 0) {
    event("utm_tracking", utmData);
  }
}

function extractUTMParams(route) {
  const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  const utmData = {};
  utmKeys.forEach((key) => {  
    if (route.query[key]) utmData[key] = route.query[key];
  });
  return utmData;
}

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || ''
  if (to.meta.css) {
    await global.loadCSS(to.meta.css)
  }
  next();
});

router.isReady().then(() => {
  trackPage(router.currentRoute.value);
});

router.afterEach((to) => {
  if (to.meta?.title) document.title = to.meta.title;

  if (to.meta?.description) {
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', to.meta.description);
  }

  trackPage(to);
});

const head = createHead()

app.use(gtag)
    .use(router)
    .use(VueAxios, axios)
    .use(head)
    .mount('#app')
